export default __webpack_public_path__ + "static/media/barropp.17cb8be6.png";